import * as React from 'react'

import { BlankSlate, Button } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  canCreateJobPostings: boolean
  noOpenPositions: boolean
}
export const EmptyListView = ({ canCreateJobPostings, noOpenPositions }: Props) => {
  const { navigation } = useNavigation()
  return (
    <BlankSlate
      illustration="complaints"
      title={
        noOpenPositions
          ? i18n.t('ats.open_positions.empty_view.no_published_jobs_title')
          : i18n.t('ats.open_positions.empty_view.no_results_title')
      }
      description={
        noOpenPositions
          ? i18n.t('ats.open_positions.empty_view.no_published_jobs_description')
          : i18n.t('ats.open_positions.empty_view.no_results_description')
      }
    >
      {noOpenPositions && canCreateJobPostings && (
        <Button.Router to={navigation.ats.jobs.new.fullPath()} iconName="add">
          {i18n.t('ats.jobs.new_job')}
        </Button.Router>
      )}
    </BlankSlate>
  )
}
